<template lang="pug">
  v-select(
    :items="limits"
    :label="label"
    :value="currentLimit"
    @change="setPaginationLimit"
  )
</template>

<script>

export default {
  name: 'PaginationLimit',
  props: {
    limits: {
      type: Array,
    },
    currentLimit: {
      type: Number,
    },
    label: {
      type: String,
      default: 'Items per page',
    },
  },
  methods: {
    setPaginationLimit(value) {
      this.$emit('change:limit', value);
    },
  },
};
</script>
